import type { ReactNode } from 'react';

export const TiptapMenubar = ({
   menubarEnd,
   children,
}: {
   /** Pinned on the right, outside the scroll area (e.g. the mode toggle). */
   menubarEnd?: ReactNode;
   children: ReactNode;
}) => (
   <div className="sticky top-0 z-[1] flex items-center rounded-lg border border-gray-300 bg-gray-50 p-1">
      {/* The buttons stay on one line and scroll horizontally in the space
          left free by the pinned end control. scrollbar-minimal keeps the
          scroll affordance quiet (thin gray thumb) instead of a chunky
          native bar over the icons. */}
      <div className="scrollbar-minimal flex min-w-0 flex-1 items-center overflow-x-auto">
         {children}
      </div>
      {menubarEnd != null && <div className="flex shrink-0 items-center ps-2">{menubarEnd}</div>}
   </div>
);
